import axios from 'axios';

let Country: any = {};

Country.getListCountry = async ()=>{
      return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/get/listes/pays`)
}

Country.getCountryById = async (id: any) =>{
     return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/get/pays/ById/${id}`)
}

export default Country;